import React from 'react';
import { useInView } from 'react-intersection-observer';
import { useSectionData } from '../hooks/useSectionData';
import { fetchSkills, attr } from '../services/api';

const CATEGORY_ORDER = ['language', 'framework', 'tool', 'cloud', 'database', 'other'];
const CATEGORY_LABELS = {
  language:  'Languages',
  framework: 'Frameworks & Libraries',
  tool:      'Tools & DevOps',
  cloud:     'Cloud & Infrastructure',
  database:  'Databases',
  other:     'Other',
};

export default function Skills() {
  const items = useSectionData(fetchSkills);
  const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });

  if (!items) return null;

  // Group by category
  const grouped = {};
  items.forEach(item => {
    const a = attr(item);
    const cat = (a.category || 'other').toLowerCase();
    if (!grouped[cat]) grouped[cat] = [];
    grouped[cat].push(a.name);
  });

  const categories = CATEGORY_ORDER.filter(c => grouped[c]?.length > 0);

  return (
    <section id="skills" ref={ref} className={`section${inView ? ' visible' : ''}`}>
      <div className="container">
        <header className="section-header">
          <p className="section-label">skills</p>
          <h2 className="section-title">Tech Stack</h2>
          <div className="section-line" />
        </header>

        <div className="skills-categories">
          {categories.map(cat => (
            <div key={cat} className="skill-category">
              <h3>{CATEGORY_LABELS[cat] || cat}</h3>
              <div className="skill-tags">
                {grouped[cat].map(name => (
                  <span key={name} className="skill-tag">{name}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
